const terminationByTheContractor = `
    <table align="center" cellpadding="0" cellspacing="0" width="600"  style="border-collapse: collapse;">
        <tr>
            <td>
                <img height="70" src="http://fcstoragebr.blob.core.windows.net/images/Fcamara/Logotipo-Horizontal-FCamara-2015.png">
            </td>
        </tr>
        <tr>
            <td align="center" height='100px'>
                <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>DISTRATO DE CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE INFORMÁTICA</strong></p>
            </td>
        </tr>
        <tr>
            <td>
            <div class="main">

                <p>
                    Pelo presente instrumento, e na melhor forma de direito, de um lado, <strong> FCAMARA CONSULTORIA E FORMAÇÃO EM INFORMÁTICA LTDA</strong>, estabelecida à Rua Bela Cintra, 986, 2º andar, CEP 01415-906, Consolação - São Paulo/SP, inscrita no CNPJ/MF sob o nº. 03.775.758/0001-90, doravante designado CONTRATANTE. E, de outro <strong>{{companyname}}</strong>, regularmente inscrita no CNPJ/MF sob o nº {{companycnpj}}, com sede na {{companyaddress}}, nº{{companynumber}}, CEP. {{companycep}}, {{companycity}}/{{companystate}}, doravante designada <strong>CONTRATADA</strong>.
                </p>

                <p>
                    A <strong>CONTRATADA</strong> decide rescindir nesta data o <strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS EM INFORMÁTICA</strong> firmado em <strong>{{contractstart}}</strong>
                </p>

                <p>
                    As partes declaram que o pagamento referente ao saldo remanescente de seus direitos e haveres pelos serviços prestados até a data de encerramento, será realizado no máximo de 15 (quinze) dias corridos contados da data de assinatura por ambas as PARTES deste instrumento, emissão de nota fiscal e entrega dos equipamentos em comodato desde a assinatura do contrato.
                </p>

                <p>
                    O <strong>CONTRATADO</strong> tem o prazo de 05 (cinco) dias a partir da assinatura deste para devolução dos equipamentos na sede da <strong>CONTRATANTE</strong>, no endereço: Rua Bela Cintra, 986, 2º andar – Consolação – São Paulo/SP, CEP 01415-906. Caso os equipamentos não sejam entregues no prazo mencionado, automaticamente presume-se autorização tácita para o desconto dos valores a receber no importe de R$ 3.500,00 (três mil e quinhentos reais).
                </p>

                <p>
                    E, por estarem assim justas, certas e contratadas, as partes assinam o presente instrumento em 02 (duas) vias em igual teor e forma na presença das testemunhas abaixo assinadas.
                </p>

                <br>
                </td>
                </tr>
                <tr>
                <td align="center" height='60px'>

                <p style="text-align: center; margin-top: 50px;">
                    <strong>São Paulo</strong>, {{contractend}}
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        <strong>FCAMARA CONSULTORIA E FORMACAO EM INFORMATICA LTDA
                        CONTRATANTE</strong>
                    </span>
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        {{companyname}}<br>
                    </span>
                </p>

                <!-- TESTEMUNHASSSS -->
                <p style="margin-top: 50px;">
                    <strong>TESTEMUNHAS</strong>
                </p>
                <div class="testemunhas" style="margin: 0; text-align: left;">
                    <table style="width: 100%;">
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td style="width: 50%;">
                                    <span>
                                        1. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                                <td style="width: 50%;">
                                    <span>
                                        2. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </td>
        </tr>
    </table>
`;

export default terminationByTheContractor;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentTemplates/terminationByTheContractor.ts